import { MessageType } from "../../Constant";
import { setNotificationMessage } from "../actions/notificationAction";
import { hideLoading } from "../../shared/widgets/bar-loader/src";
import {
  fetchDistanceReportData,
  fetchMobileTicketData,
  fetchDistanceReportDetails,
  fetchMobitTicketsDetails,
  fetchMobileSettlementDetails,
  uploadExcelFile,
  runSettlement,
  fetchPassDetails,
  fetchPassSettlementDetails,
  fetchPassData,
  generateDistributionService,
  fetchPassRevenueDistribution,
  fetchOperatorWiseReport,
} from "../../services/distanceReportService";
import {
  distanceReportFetched,
  mobileTicketFetched,
  distanceReportDetailsFetched,
  mobileTicketsDetailsFetched,
  mobileSettlementDetailsFetched,
  distanceReportDataSync,
  passFetched,
  passDetailsFetched,
  passSettlementDetailsFetched,
  operatorWiseReportFetched,
  distanceUploadSheetFailure,
} from "../actions/distanceReportAction";
import { createAllActionCreators } from "./actionCreatorUtil";

const distanceReportActionCreators = {
  distanceReportAction: {
    service: fetchDistanceReportData,
    action: distanceReportFetched,
  },
  mobileTicketAction: {
    service: fetchMobileTicketData,
    action: mobileTicketFetched,
  },
  distanceReportDetailsAction: {
    service: fetchDistanceReportDetails,
    responseFn: (response, params) => {
      const { dispatch, loaderType } = params;
      dispatch(hideLoading(loaderType));
      dispatch(distanceReportDetailsFetched(response));
      dispatch(distanceReportDataSync(response.dataSyncStatus));
    },
  },
  mobileTicketsDetailsAction: {
    service: fetchMobitTicketsDetails,
    action: mobileTicketsDetailsFetched,
  },
  mobileSettlementDetailsAction: {
    service: fetchMobileSettlementDetails,
    action: mobileSettlementDetailsFetched,
  },
  uploadExcelFileAction: {
    service: uploadExcelFile,
    action: distanceReportDataSync,
    responseNotification: {
      status: true,
    },
    upload: {
      status: true,
      notificationMessage: "Upload Failed",
      errorAction: distanceUploadSheetFailure,
      errorActionMessage: (err) => (err.error
        ? `${err.message}: ${JSON.stringify(err.error)}`
        : err.message || "Something went wrong"),
    },
  },
  runSettlementAction: {
    service: runSettlement,
    responseFn: (response, params) => {
      const { dispatch, loaderType, callBack } = params;
      dispatch(hideLoading(loaderType));
      dispatch(
        setNotificationMessage({
          type: MessageType.SUCCESS,
          message: "Settlement successfull",
        }),
      );
      if (callBack && typeof callBack === "function") callBack();
    },
  },
  passAction: {
    service: fetchPassData,
    action: passFetched,
  },
  passDetailsAction: {
    service: fetchPassDetails,
    action: passDetailsFetched,
  },
  passSettlementDetailsAction: {
    service: fetchPassSettlementDetails,
    action: passSettlementDetailsFetched,
  },
  generateDistributionAction: {
    service: generateDistributionService,
    responseFn: (response, params) => {
      const { dispatch, loaderType, callBack } = params;
      dispatch(hideLoading(loaderType));
      dispatch(
        setNotificationMessage({
          type: MessageType.SUCCESS,
          message: "Distribution generated successfully",
        }),
      );
      if (callBack && typeof callBack === "function") callBack();
    },
  },
  passRevenueDistributionAction: {
    service: fetchPassRevenueDistribution,
    action: passDetailsFetched,
  },
  operatorWiseReportAction: {
    service: fetchOperatorWiseReport,
    action: operatorWiseReportFetched,
  },
};

export const {
  distanceReportAction,
  mobileTicketAction,
  distanceReportDetailsAction,
  mobileTicketsDetailsAction,
  mobileSettlementDetailsAction,
  uploadExcelFileAction,
  runSettlementAction,
  passAction,
  passDetailsAction,
  passSettlementDetailsAction,
  generateDistributionAction,
  passRevenueDistributionAction,
  operatorWiseReportAction,
} = createAllActionCreators(distanceReportActionCreators);
